import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = { class: "font-bold text-center pt-5" }
const _hoisted_2 = { class: "mt-10 w-screen overflow-hidden" }
const _hoisted_3 = { class: "flex flex-col justify-center items-center" }
const _hoisted_4 = { class: "w-10/12 md:w-1/2" }
const _hoisted_5 = { class: "w-10/12 md:w-1/2" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Low")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Medium")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("High")
const _hoisted_9 = { class: "w-10/12 md:w-1/2" }
const _hoisted_10 = { class: "w-10/12 md:w-1/2" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Click to upload ")
const _hoisted_12 = { class: "w-10/12 md:w-1/4 md:ml-16" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode("Loading")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("Submit")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_GoBack = _resolveComponent("GoBack")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_UploadOutlined = _resolveComponent("UploadOutlined")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_upload = _resolveComponent("a-upload")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Header),
    _createVNode(_component_GoBack),
    _createElementVNode("h2", _hoisted_1, _toDisplayString(_ctx.paramId ? "Edit Allergy" : "Add a New Allergy"), 1),
    _createElementVNode("section", _hoisted_2, [
      _createVNode(_component_a_form, _mergeProps({
        class: "",
        model: _ctx.formState,
        name: "validate_other"
      }, _ctx.formItemLayout, { onFinish: _ctx.onFinish }), {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_a_form_item, {
                label: "Name",
                name: "name",
                rules: [
              !_ctx.paramId && {
                required: true,
                message: 'Please input the name!',
              },
            ]
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input, {
                    value: _ctx.formState.name,
                    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formState.name) = $event)),
                    placeholder: "Please add a name",
                    defaultValue: _ctx.currentAllergy && _ctx.currentAllergy.name
                  }, null, 8, ["value", "defaultValue"])
                ]),
                _: 1
              }, 8, ["rules"])
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_a_form_item, {
                name: "severity",
                label: "Severity",
                "has-feedback": "",
                rules: [
              !_ctx.paramId && {
                required: true,
                message: 'Please select a severity!',
              },
            ]
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_select, {
                    value: _ctx.formState.severity,
                    "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formState.severity) = $event)),
                    placeholder: "Please select a severity",
                    defaultValue: _ctx.currentAllergy && _ctx.currentAllergy.severity
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_select_option, { value: "Low" }, {
                        default: _withCtx(() => [
                          _hoisted_6
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_select_option, { value: "Medium" }, {
                        default: _withCtx(() => [
                          _hoisted_7
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_select_option, { value: "High" }, {
                        default: _withCtx(() => [
                          _hoisted_8
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["value", "defaultValue"])
                ]),
                _: 1
              }, 8, ["rules"])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_a_form_item, {
                name: "symptoms",
                label: "Symptoms"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_select, {
                    value: _ctx.formState['symptoms'],
                    "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formState['symptoms']) = $event)),
                    mode: "multiple",
                    placeholder: "Please select symptoms",
                    defaultValue: _ctx.currentAllergy && _ctx.currentAllergy.symptoms
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.symptomsList, (symptomp) => {
                        return (_openBlock(), _createBlock(_component_a_select_option, {
                          key: symptomp,
                          value: symptomp
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(symptomp), 1)
                          ]),
                          _: 2
                        }, 1032, ["value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["value", "defaultValue"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_a_form_item, {
                name: "image",
                label: "Image"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_upload, {
                    action: _ctx.imageUrl,
                    headers: _ctx.headers,
                    fileList: _ctx.formState.image,
                    "onUpdate:fileList": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formState.image) = $event)),
                    onChange: _ctx.handleChange,
                    name: "image",
                    "list-type": "picture"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_button, null, {
                        icon: _withCtx(() => [
                          _createVNode(_component_UploadOutlined)
                        ]),
                        default: _withCtx(() => [
                          _hoisted_11
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["action", "headers", "fileList", "onChange"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_12, [
              (_ctx.loading)
                ? (_openBlock(), _createBlock(_component_a_button, {
                    key: 0,
                    class: "w-full",
                    type: "primary",
                    loading: ""
                  }, {
                    default: _withCtx(() => [
                      _hoisted_13
                    ]),
                    _: 1
                  }))
                : (_openBlock(), _createBlock(_component_a_button, {
                    key: 1,
                    class: "w-full",
                    type: "primary",
                    "html-type": "submit"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_14
                    ]),
                    _: 1
                  }))
            ])
          ])
        ]),
        _: 1
      }, 16, ["model", "onFinish"])
    ])
  ], 64))
}